import { ReactNode } from 'react';
import i18n from '../../i18n';
import { FlowType } from '../../hooks/zustandHooks';

export type WelcomePageTypes =
  | Exclude<FlowType, 'ReconfirmationFlow' | 'ReauthenticationFlow'>
  | 'DashboardInviteCISFlow';

type WelcomePageProps = {
  [k in WelcomePageTypes]: {
    title: string;
    description: (props?: { customerName?: string }) => ReactNode;
  };
};

const t = i18n.t;
export const WelcomePageProps: WelcomePageProps = {
  OpenBankingFlow: {
    title: 'Connect your bank account',
    description: () => (
      <p className="text-base sm:text-md block leading-6 font-normal">
        {t(
          `We'll guide you through a simple, secure journey to select your bank and connect it using open banking. With your permission, we'll retrieve your transaction data to help our trusted partners make informed decisions tailored to your needs.`
        )}
      </p>
    )
  },
  DashboardInviteCISFlow: {
    title: 'Confirm identity',
    description: props => (
      <>
        <p className="text-base sm:text-md block leading-6 font-normal">
          {t(`You have been invited by {{customerName}} to connect your bank account(s).`, {
            customerName: props?.customerName
          })}
        </p>
        <p className="text-base sm:text-md block leading-6 font-normal mb-4">
          {t('Estimated time is ~')}
          <strong>{t('10 minutes')}</strong>.
        </p>
      </>
    )
  },
  CreditInformationFlow: {
    title: 'Connect your Accounts',
    description: () => (
      <>
        <p className="text-base sm:text-md block leading-6 font-normal">
          {t(
            `We’ll guide you through a simple, secure journey to select your bank and connect it using open banking for the purpose of making an affordability assessment for car hire charges in relation to a car insurance claim.`
          )}
        </p>
        <p className="text-base sm:text-md block leading-6 font-normal mt-4">
          {t(
            `With your permission we’ll also run a check with TransUnion, a UK Credit Reference Agency to access your Credit Report to see if there are any other financial accounts you may hold and have not included. Rest assured, it will not affect your credit score.`
          )}
        </p>
      </>
    )
  },
  DocumentUploadFlow: {
    title: 'Manually connect your account',
    description: () => (
      <>
        <p className="text-base mb-3 sm:text-md block leading-6 font-normal">
          {t(
            `We’ll guide you through a simple, secure journey to manually connect your account and securely analyze your statements to help our trusted partners make informed decisions tailored to your needs.`
          )}
        </p>
        <p className="text-base sm:text-md block leading-6 font-normal">
          {t(`Your data is encrypted and used only for this purpose.`)}
        </p>
      </>
    )
  }
};
